import {css} from "lit";

export const annotationImageStyles = css`
	.thumbnail-notes-btn {
		display: block;
		float: left;
		background-color: transparent;
		border: none;
		text-align: inherit;
		margin-right: 10px;
	}

	.thumbnail, .thumbnail-loading, .thumbnail-error {
		display: block;
		box-sizing: content-box;
		width: 100px;
		height: 100px;
		padding: 10px;
		margin: 5px 10px;
		border: 1px solid var(--pn-outline-annotation-thumbnail-border-color);
	}
	.thumbnail > *, .thumbnail-loading > *, .thumbnail-error > * {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
		font-size: var(--pn-font-size-base);
		color: var(--pn-thumbnail-loading-text-color);
	}

	.pn-notes {
		/* Because the image is floated, the parent div collapses to 0 height without some help */
		min-height: 132px;

		/* Match rich text editor text color */
		color: var(--pn-input-text-color);

		font: unset;
		font-size: var(--pn-font-size-base);
		letter-spacing: normal;
		text-transform: none;
		overflow-wrap: break-word;
		cursor: pointer;
	}

	.pn-notes p {
		margin: 0;
	}

	.mode-sidebar-drag .pn-notes {
		cursor: grab;
	}

	.placeholder {
		display: none;
	}

	/* Loading dots */
	.loading-box {
		background-color: var(--pn-thumbnail-loading-bg-color);
	}
	.loading-box .animation {
		display: flex;
		justify-content: center;
		margin: 0px auto 15px;
	}
	.loading-box .animation .animation-item {
		display: block;
		width: 8px;
		height: 8px;
		background-color: var(--pn-thumbnail-loading-icon-color);
	}
	.loading-box .animation .animation-item:not(:last-child) {
		margin-right: 9px;
	}

	.thumbnail-error .error-box {
		background-color: var(--pn-thumbnail-error-bg-color);
	}
	.thumbnail-error .error-box i {
		display: block;
		font-size: calc(var(--pn-font-size-large) + 7px);
		margin: 5px auto 10px;
		background-color: var(--pn-thumbnail-loading-icon-color);
	}

	.annotation-image:hover .pn-notes.empty .placeholder,
	.annotation-image:focus .pn-notes.empty .placeholder {
		padding-top: 3px;
		color: var(--pn-annotation-notes-text-color-empty);
		font-size: var(--pn-font-size-small);
		display: block;
	}

	.annotation-image .list-item-footer {
		margin-top: 5px;
	}
`;
